import React from "react";

import { Button } from "@magnetic/button";
import { Flex } from "@magnetic/flex";
import { Text } from "@magnetic/text";

type SelectedRowsCountProps = {
  selectAllRowsCallback: (value: boolean) => void;
  selectedRowsLength: number;
  totalRows: number;
};

type SelectAllRowsButtonProps = SelectedRowsCountProps;

const SelectAllRowsButton = ({
  selectAllRowsCallback,
  selectedRowsLength,
  totalRows
}: Readonly<SelectAllRowsButtonProps>) => (
  <Flex align="center" gap={16}>
    <Text aria-label="selected rows text" weight="semi-bold">{`item${
      selectedRowsLength > 1 ? "s" : ""
    } selected`}</Text>
    {selectedRowsLength < totalRows && (
      <Button
        aria-label="select all rows"
        id="mds-rebuild-bulk-action-bar-select-all-items"
        kind="tertiary"
        onClick={selectAllRowsCallback}
      >
        Select all {totalRows} items
      </Button>
    )}
  </Flex>
);

export const SelectedRowsCount = (props: Readonly<SelectedRowsCountProps>) => {
  const { selectedRowsLength } = props;
  return (
    <Flex
      align="center"
      className="mds-rebuild-bulk-action-bar-items"
      gap={12}
      justify="center"
    >
      <Flex
        align="center"
        className="mds-rebuild-bulk-action-bar-items-amount"
        justify="center"
      >
        <span aria-label="selected rows amount">{selectedRowsLength}</span>
      </Flex>
      <SelectAllRowsButton {...props} />
    </Flex>
  );
};
